import config from "../config";
import URL from "./url";
import base64 from "./base64";

const styles = {
  original: "saveexif,1",
  wx_icon_80: "resize,m_fill,w_80,h_80",
  weixin_120: "resize,m_fill,w_120,h_80,limit_1/quality,q_90/format,jpg",
  avatar_150: "resize,m_fill,w_150,h_150,limit_1",
  qrcode_180: "resize,m_fill,w_360,h_360,limit_1/quality,Q_90/format,jpg",
  wx_170_210: "resize,m_fill,w_170,h_210,limit_1/format,jpg",
  wx_690_170: "resize,m_fill,w_690,h_170,limit_0/format,jpg",
  wx_750_435: "resize,m_fill,w_750,h_435,limit_1/format,jpg",
  wx_110_85: "resize,m_fill,w_220,h_170,limit_1/format,jpg",
  wx_560_n: "resize,m_lfit,w_560,limit_1/format,jpg",
  wx_750_n: "resize,m_lfit,w_1366",
  wx_750_n_noformat: 'resize,m_lfit,w_750',
  wx_750_n_rotate: "resize,m_lfit,w_1366/rotate,90",
  wx_1920_n: "resize,m_lfit,w_1920,limit_1",
  wx_750_head: "resize,m_lfit,w_750,limit_1",
  wx_750_320: "resize,m_fill,w_750,h_420,limit_0/quality,Q_90/format,jpg",
  wx_250_160_top: "resize,m_lfit,w_250,limit_1/crop,x_0,y_0,w_250,h_160,g_north/format,jpg",
  wx_250_160: "resize,m_lfit,w_250,limit_1/quality,Q_60/format,jpg",
  wx_375_crop: "resize,m_lfit,w_375,limit_1/crop,x_0,y_0,w_375,h_250,g_north/quality,Q_60",
  wx_375_crop_vertical: "resize,m_lfit,w_375,limit_1/crop,x_0,y_0,w_375,h_504/quality,Q_60",
  wx_375_240: "resize,m_lfit,w_375,limit_1/quality,Q_60/format,jpg",
  wx_375_240_vertical: "resize,m_lfit,h_482,limit_1/quality,Q_60/format,jpg",
  wx_108_108: "resize,m_lfit,h_108,limit_1/crop,x_0,y_0,w_108,h_108,g_northformat,jpg/",
  wx_168_168: "resize,m_lfit,w_168,limit_1/crop,x_0,y_0,w_168,h_168,g_north/format,jpg",
  wx_375_375: "resize,m_lfit,w_375,limit_1/crop,x_0,y_0,w_375,h_375,g_north/format,jpg",
  wx_375_375_square: "resize,m_fill,s_375,limit_0/crop,x_0,y_0,w_375,h_375,g_north",
  wx_180_120: "resize,m_fill,w_180,h_120,limit_0/crop,x_0,y_0,g_north",
  wx_250_350: "resize,m_fill,w_250,h_350,limit_0/crop,x_0,y_0,g_north", //5:7 用于热门图片的垂直图显示
  wx_555_350: "resize,m_fill,w_555,h_350,limit_0/crop,x_0,y_0,g_north", //3:2 用于热门图片的水平图显示
  wx_168_n: "resize,m_lfit,w_168,limit_1/format,jpg",
  wx_690_400: "resize,m_fill,w_690,h_400,limit_0/quality,Q_90/format,jpg",
  wx_750_420: "resize,m_fill,w_750,h_420,limit_0/quality,Q_90/format,jpg",
  wx_164_200: "resize,m_fill,w_164,h_200,limit_0/quality,Q_90/format,jpg",
  wx_590_n: "resize,m_lfit,w_590,limit_1/quality,Q_90/format,jpg",
  wx_share: "resize,m_fill,w_215,h_168,limit_0/quality,Q_90/format,jpg",
  redpackage_logo: "resize,m_lfit,h_120,limit_1/sharpen,100",
  background: "resize,m_lfit,w_1500,limit_0",
  background_ipx: "resize,m_lfit,w_1500,h_2720,limit_0",
  face: "resize,m_lfit,w_1920,limit_0",
  "wx_gallery_mode_1": "resize,m_fill,w_420,h_280",
  "wx_gallery_a_1": "resize,m_lfit,w_420",
  "wx_gallery_mode_2": "resize,m_fill,w_375,h_250",
  "wx_gallery_a_2": "resize,m_lfit,w_375",
  "wx_gallery_mode_3": "resize,m_lfit,w_750",
};
const image = {
  protocol: function (path = "") {
    return path.replace(/^http(s)*:/, "");
  },
  url: function (path, params, id) {
    //console.log(path);
    var result = URL(
      path && path.indexOf('http') === 0 ? (
        path
      ) : config.image(
        id,
        window.__current_gallery__ && window.__current_gallery__.useglobal
      ) +
      "/" +
      path
    );
    var query = result.query || {};
    result.setParams(Object.assign(query, params || {}));
    return result.toString(false);
  },
  scaleShape: (x, y, width, height, noShapeScale = false) => {
    // 首先向四个方向，均扩展30像素
    // let border = 0.25;
    // let min_size = 150;
    // let widthBorder = Math.round(width * border);
    // let heightBorder = Math.round(height * border);

    // width += widthBorder * 2;
    // height += heightBorder * 2;

    // x -= widthBorder;
    // y -= heightBorder;

    // // 如果还在小于我们要的尺寸
    // if (width < min_size) {
    //   x -= (min_size - width) / 2;
    //   width = min_size;
    // }
    // if (height < min_size) {
    //   y -= (min_size - height) / 2;
    //   height = min_size;
    // }

    // // 把整个图像做成正方形
    // if (width < height) {
    //   let between = height - width;
    //   x -= between / 2;
    //   width = height;
    // } else if (height < width) {
    //   height = width;
    // }
    // return `crop,x_${Math.round(x)},y_${Math.round(y)},w_${Math.round(
    //   width
    // )},h_${Math.round(height)},g_nw`;

    if (noShapeScale) {
      return `crop,x_${x},y_${y},w_${width},h_${height},g_nw`;
    } else {
      // 直接找中心点
      let longSide = Math.min(1920, Math.max(140, Math.max(width, height)) * 2);
      let center = [x + width / 2, y + (height / 2) * 0.8];
      let newCenter = [center[0] - longSide / 2, center[1] - longSide / 2];

      return `crop,x_${Math.round(newCenter[0])},y_${Math.round(newCenter[1])},w_${Math.round(
        longSide
      )},h_${Math.round(longSide)},g_nw`;
    }
  },
  style: function (path, styleName, extra, id) {
    var result = [];
    if (typeof styles[styleName] != "undefined") {
      result = result.concat(styles[styleName].split("/"));
    }

    if (extra && extra.fixedFilter) {
      // 人脸的录入，使用的是filter路径，但实际应该使用source路径
      if (!path) {
        return path;
      }
      path = path.replace(/filter\//, `source/`);
    }

    // 如果后缀名为.gif，则去掉文件格式的转换，并且去掉水印设置
    if (path && path.match(/\.gif$/ig)) {
      result = result.filter(it => it !== 'format,jpg' && it.indexOf('quality,') < 0);
      // delete extra.watermark;
      if (extra) {
        delete extra.watermark;
      }
    }

    if (extra) {
      if (extra.shape) {
        let { width, height, x, y } = extra.shape;
        result.push(image.scaleShape(x, y, width, height, extra.noShapeScale));
      }

      if (extra.watermark_fill) {
        result.push(
          `watermark,image_${base64.safe(extra.watermark_fill)},t_${60},fill_1,padx_100,pady_100`
        );
      }
      else if (extra.watermark) {
        const getWatermarkStyle = (watermark) => {
          var icon =
            watermark.icon +
            (watermark.percent
              ? "?x-oss-process=image/resize,P_" + watermark.percent
              : "");
          var border = watermark.noborder ? 0 : 10;
          var vBorder = border;
          var hBorder = border;
          let borderPercent = 1;
          if (extra.targetWidth) {
            borderPercent = extra.targetWidth / 3840;
          }
          if (typeof watermark.h == 'number') {
            hBorder = Math.round(watermark.h * borderPercent);
          }
          if (typeof watermark.v == 'number') {
            vBorder = Math.round(watermark.v * borderPercent);
          }

          return (
            `watermark,image_${base64.safe(icon)},t_${watermark.opacity || 100
            },g_${watermark.align},y_${vBorder},x_${hBorder}`
          );
        }

        let adjust = 'h';
        if (typeof extra.width == 'number' && typeof extra.height == 'number') {
          if (Number(extra.height) > Number(extra.width)) {
            adjust = 'v';
          }
        }

        if (extra.watermark instanceof Array) {
          extra.watermark.forEach((watermark) => {
            if (watermark && watermark.adjust === adjust) {
              result.push(getWatermarkStyle(watermark));
            } else if (watermark && typeof watermark.adjust == 'undefined') {
              result.push(getWatermarkStyle(watermark));
            }
          });
        } else {
          result.push(getWatermarkStyle(extra.watermark));
        }
      }
      if (extra.webp && window.__isSupportWebp) {
        let hasConfigFormat = false;
        result = result.map((cfg) => {
          if (cfg && cfg.indexOf('format,') === 0) {
            cfg = `format,webp`;
            hasConfigFormat = true;
          }

          return cfg;
        });

        if (!hasConfigFormat) {
          result.push(`format,webp`);
        }
      }
    }
    var process = null;
    if (result && result.length) {
      result = result.filter((it) => !!it);
      if (result && result.length) {
        process = {
          "x-oss-process": "image/" + result.join("/"),
        };
      }
    }
    if (path) {
      return image.url(path, process, id);
    } else {
      return "";
    }
  },
  direct: (path, name) => {
    var url =
      `${window.location.protocol}//${window.configDetail.use_global * 1 ? "iglobal" : "image"
      }1${window.__basename}/` +
      path +
      (name ? "!" + name : "");
    return image.protocol(url);
  },
  downloadImage: (path, name) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", path, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([xhr.response]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;

          window.document.body.appendChild(save_link);
          save_link.click();

          window.document.body.removeChild(save_link);
          resolve();
        }
      };

      xhr.send();
    });
  },
  decodeFaceUrl: (url) => {
    if (url.indexOf('http') != 0) {
      url = window.location.protocol + url;
    }
    let parse = URL(url);
    if (parse && parse.query) {
      let process = parse.query['x-oss-process'];
      if (process) {
        process = decodeURIComponent(process);
        let array = process.split('/');
        let result = {};
        try {
          array.forEach(str => {
            let p = (str || "").split(',');
            if (p && p.length >= 2) {
              if (p[0] === 'crop') {
                for (var i = 1; i < p.length; i++) {
                  let one = p[i].split('_');
                  if (one && one.length >= 2) {
                    if (['x', 'y'].indexOf(one[0]) > -1) {
                      result[one[0]] = Number(one[1]);
                    }
                    if (one[0] === 'w') {
                      result.width = Number(one[1]);
                    }
                    if (one[0] === 'h') {
                      result.height = Number(one[1]);
                    }
                  }
                }
              }
            }
          });
        } catch (e) {

        }
        if (Object.keys(result).length >= 4) {
          return {
            src: (parse.pathname || "").replace(/^\//, ''),
            shape: result
          };
        }
      }
    }
    return {
      src: url,
      shape: null
    };
  }
};

export let protocol = image.protocol;
export let url = image.url;
export let style = image.style;
export let direct = image.direct;
export let decodeFaceUrl = image.decodeFaceUrl;

export let downloadImage = image.downloadImage;

export default image;
